// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveTwoToneSvg from "@fishx/icons-svg/es/asn/SaveTwoTone";
import FishxIcon from '../components/FishxIcon';

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveTwoToneSvg
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
export default React.forwardRef(SaveTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SaveTwoTone.js
// module id = 4064
// module chunks = 0